import { avisoDeDudasQueBloquean } from "@/lib/generacionResumen";

interface AvisoDeDudasQueBloqueanProps {
  cantidad: number;
  onIr: () => void;
}

/**
 * El aviso rojo de las fases 2 y 3: lo que bloquea la emisión sigue vivo aunque
 * se trabaje en otra fase. Avisa, no frena: el trabajo de la fase continúa y el
 * botón lleva a la primera duda que bloquea.
 */
export function AvisoDeDudasQueBloquean({ cantidad, onIr }: AvisoDeDudasQueBloqueanProps) {
  return (
    <section
      role="alert"
      className="bg-danger-soft flex flex-wrap items-center gap-2.5 rounded-xl py-[0.5625rem] pr-3 pl-3.5"
    >
      <span aria-hidden className="bg-danger-dot size-2 shrink-0 rounded-full" />
      <span className="text-danger-texto-fuerte min-w-0 flex-1 text-[0.78125rem] font-bold text-pretty">
        {avisoDeDudasQueBloquean(cantidad)}
      </span>
      <button
        type="button"
        onClick={onIr}
        className="bg-card text-danger-texto-fuerte rounded-[0.5625rem] px-[0.6875rem] py-1.5 text-xs font-bold"
      >
        Ir a las dudas
      </button>
    </section>
  );
}
